import React from 'react';

const ValueCard = (props) => {
    const { title, value, className, loading, format } = props;
    
    if (loading) {
        return (
            <div className={`${className} card text-center`}>
                <p>Loading...</p>
            </div>
        );
    }

    return (
        <div className={`${className} card text-center`}>
            <p>{title}</p>
            <h5>{format ? format(value) : value}</h5>
        </div>
    );
};

export default ValueCard;
